import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const HomeIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="black" fill-opacity="0.87" />
      </svg>
    )
  },
)
